import { cn } from "@/utils/cn";

export default function ActionButton({
  icon,
  onClick,
  disabled,
  children,
  className,
}: {
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  children: string;
  className?: string;
}) {
  return (
    <>
      <button
        type="button"
        disabled={disabled}
        onClick={onClick}
        className={cn(
          `p-2 rounded-[48px] transition-all border group border-[#d6d6de] flex items-center font-pretendard text-sm gap-x-[13px] pr-[22px] w-fit ${!disabled && "hover:text-white hover:bg-[#0E59C6]"} disabled:cursor-default disabled:opacity-30`,
          className
        )}
      >
        <div
          className={`w-[32px] h-[32px] font-black ${!disabled && "group-hover:bg-white group-hover:text-[#0E59C6]"} text-xl text-white bg-[#E2E2E8] flex justify-center items-center rounded-full`}
        >
          {icon}
        </div>
        <span
          className={`font-pretendard ${!disabled && "group-hover:text-white"} text-sm`}
        >
          {children}
        </span>
      </button>
    </>
  );
}
